export function afterLoadData(): void {
  setTimeout(() => {
    if (!this.isDestroyed) {
      this.validateCells();
    }
  });
}
